/**
 * Created by Amit panghal
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {TractorBeamHelper} from "../../utils/TractorBeamHelper";
import {TractorBeamStateMatrix} from "../../utils/TractorBeamStateMatrix";
import {TractorBeamParsedGameData} from "../server/data/TractorBeamParsedGameData";
import {BasicStateReelSymbol} from "../symbols/BasicStateReelSymbol";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";

export class TractorBeamFreeSpinEvent {
    public static ADD_SYMBOL_TO_CC = "tractorBeamFreespinEvent_addSymbolToCC";
}

export class TractorBeamAddFreespinController extends WinPresentationController {
    //Class properties
    private _numberOfExtraFreespinsAwarded:number;
    private _scatterExtraSpinPositions:number[];
    private _scatterSymbolStates:TractorBeamStateMatrix<number>;
    private _winSymbolsArray:any;
    private _beamOutLayer:ScalableLayer;
    private _timeline:TimelineLite | null;
    private _freespinsAddCounter:number;

    constructor(indexes:[number, number]) {
        super(indexes, {
            name : "AddFreespin",
            skippable : false
        });
        this._beamOutLayer = StageManager.getLayer(TractorBeamGameConfig.instance.LAYERS.SYMBOLS.name);
    }

    /**
     * Function to check if has extra free spin wins.
     */
    protected hasWin():boolean {
        return this._numberOfExtraFreespinsAwarded > 0;
    }

    /**
     * Function to capture parsed game data.
     * @param data
     */
    protected parseFeatureGameData(data:TractorBeamParsedGameData):void {
        this._numberOfExtraFreespinsAwarded = data.numberOfExtraFreespinsAwarded;
        this._scatterExtraSpinPositions = data.scatterExtraSpinPositions;
        this._freespinsAddCounter = data.freespinsLeft - data.numberOfExtraFreespinsAwarded;
        //console.log("FS LEFT SUBTRACTED: " + this._freespinsAddCounter);
        //console.log("FS LEFT: " + data.freespinsLeft);
    }

    /**
     * Function to start win presentation.
     */
    protected startWinPresentation():void {
        const timeline:TimelineLite = new TimelineLite({
            paused : true,
            onComplete : () => this.finish()
        });
        this._scatterSymbolStates = TractorBeamHelper.createSymbolStateMatrixFromScatterWins(<number[]>this._scatterExtraSpinPositions!);
        this._winSymbolsArray = TractorBeamHelper.getSymbolsWithState(this._scatterSymbolStates, 1);
        this.playWinAnimations(timeline);
        this._timeline = timeline;
        this._timeline.play();
    }

    /**
     * Play win animation if extra free spin won.
     * @param timeline
     */
    private playWinAnimations(timeline:TimelineLite):void {
        let soundCount:number = 1;

        for(let i:number = 0; i < this._winSymbolsArray.length; i++) {
            let winningSymbol = this._winSymbolsArray[i];
            if(winningSymbol.symbol.symName !== ReelSymbolName.WILD) {
                winningSymbol.symbol.setIsRemovedFromReel = true;
                //let freeSpinAddSprite: PIXI.Sprite = this.showAddFreespin(winningSymbol);
                //timeline.delay(0.5);
                timeline.add(() => {
                    if(winningSymbol && winningSymbol.symbol && winningSymbol.symbol.symName === "S") {

                        winningSymbol.symbol.playSpineAnimation("S", "S-win");
                        //console.log("SOUND: " + "fsPlusOne" + soundCount);
                        SlotGame.sound.playEffect("fsPlusOne" + soundCount);
                        soundCount = (soundCount === 3) ? 1 : soundCount + 1;

                        SlotGame.keypad.setZeroBetSpinCounter(++this._freespinsAddCounter);
                    }
                }, "+=0.65");

                if(i === this._winSymbolsArray.length - 1) {
                    timeline.add(() => {
                        EventHandler.dispatchEvent(new GameEvent(TractorBeamFreeSpinEvent.ADD_SYMBOL_TO_CC, true));
                    }, timeline.totalDuration() + 1.4);
                }

                //timeline.call(() => this.hideSymbols(winningSymbol.symbol, freeSpinAddSprite));
                // timeline.add(new TweenLite(freeSpinAddSprite.position, 0.3, {alpha : 0, delay : 0.3}));
                /*timeline.add(new TweenLite(freeSpinAddSprite.position, 0.7, {y: freeSpinAddSprite.position.y - 40, onComplete : () => {
                       // this._beamOutLayer.removeChild(freeSpinAddSprite);
                        if(i === this._winSymbolsArray.length -1) {
                            EventHandler.dispatchEvent(new GameEvent(TractorBeamFreeSpinEvent.ADD_SYMBOL_TO_CC, true));
                        }
                    }}));*/
            }
        }
    }

    /**
     * Function to hide symbols before animating.
     * @param winningSymbol
     * @param freeSpinAddSprite
     */
    private hideSymbols(winningSymbol:BasicStateReelSymbol, freeSpinAddSprite:PIXI.Sprite):void {
        freeSpinAddSprite.alpha = 1;
        winningSymbol.currentStateAnimation!.alpha = 0;
    }

    /**
     * Function to set symbol position.
     * @param symbol
     */
    public showAddFreespin(symbol:any):PIXI.Sprite {
        //const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("freespinAdd1")[0]);
        //sprite.position.x = Helper.getSymbolPositions(symbol.reelIndex, symbol.symbolIndex)[0] - 48;
        //sprite.position.y = Helper.getSymbolPositions(symbol.reelIndex, symbol.symbolIndex)[1] - 47;
        //sprite.scale.set(0.5, 0.5);
        //sprite.alpha = 0;
        //this._beamOutLayer.addChild(sprite);
        return new PIXI.Sprite();//sprite;
    }

    /**
     * Function to stop win presentation.
     */
    protected stopWinPresentation():void {
        if(this._timeline) {
            if(this._timeline.isActive()) {
                this._timeline.pause();
                this._timeline.kill();
            }
            this._timeline = null;
        }
    }
}
